export function round(anything: number): number {
	return Math.round((anything + Number.EPSILON) * 100) / 100;
}
